import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { SelectProfileModal, FieldFormModal } from "./Modal"
import IndividualTable from "./IndividualTable"
import {
  Check,
  ConfirmModal,
  CustomButton,
  TitleAndTable,
  WarningModal,
} from "components/Common"

import {
  getInputChangedValue,
  getNumber,
  isEmptyValues,
  onDelete,
  onDeleteToggle,
  selectCheckboxHandler,
} from "helpers/utilities"

import {
  getIndividualDetail,
  getIndividuals,
  resetIndividualSearchQuery,
  updateIndividual,
  addNewIndividual,
  deleteIndividuals,
} from "store/party/individual/actions"

//i18n
import { withTranslation } from "react-i18next"
import { ModuleIds, permissionType } from "constant"
import { insertUrlParam, appendUrl, getUrlParams, getUrlParamByKey, appendParams } from "helpers/utilities"
import moment from "moment"

const RESOURCE = ModuleIds.Individual

const Individuals = ({
  history,
  individuals,
  paging,
  onGetIndividuals,
  onAddNewIndividual,
  onUpdateIndividual,
  onDeleteIndividual,
  onResetIndividualSearchQuery,
  onGetIndividualDetail,
  individual,
  loadingIndividuals,
  updatedIndividualTime,
  t,
}) => {
  const [confirmModal, setConfirmModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(true)
  const [isClone, setIsClone] = useState(false)
  const [row, setRow] = useState({})
  const [rowDelete, setRowDelete] = useState({})
  const [rows, setRows] = useState([])

  const [rowAddNew, setRowAddNew] = useState({})
  const [rowEdit, setRowEdit] = useState(individual)

  const [warningModal, setWarningModal] = useState(false)

  const [selectModal, setSelectModal] = useState(false)


  const onGetIndividualList = (payload) => {
    insertUrlParam(payload)
    onGetIndividuals(payload)
  }

  const toggle = () => {
    setModal(prev => !prev)
  }

  const addIndividualClicks = () => {
    setIsEdit(false)
    setIsClone(false)
    setRowAddNew({})
    // toggle()
    setSelectModal(prev => !prev)
  }

  /**
   * Handling submit Individual on Individual form
   */
  const handleValidSubmit = (e, values) => {
    values.FirstVisitCompanyId = getNumber(values["FirstVisitCompanyId"])
    values.ManagementCompanyId = getNumber(values["ManagementCompanyId"])
    values.ParentId = getNumber(values["ParentId"])
    if (isEdit) {
      onUpdateIndividual({ individual: values, callback: toggle })
    } else {
      const newIndividual = {
        ...values,
      }
      delete newIndividual.Id
      // save new Individual
      onAddNewIndividual({ individual: newIndividual, history })
    }
  }

  const onCloneHandler = (param) => {
    const id = param || row?.id
    if (id) {
      setIsEdit(false)
      setIsClone(true)
      onGetIndividualDetail({
        id,
        callback: () => {
          toggle()
        },
      })
    } else setWarningModal(true)
  }

  const onEditHandler = (e, paramId) => {
    const id = paramId || row?.id
    if (id) {
      onGetIndividualDetail({
        id,
        callback: () => {
          setIsEdit(true)
          toggle()
        },
      })
    } else setWarningModal(true)
  }

  const resetState = () => {
    setRows([])
    setRow({})
  }

  const onDeleteToggleHandler = (e, param) => {
    onDeleteToggle({
      rows,
      row: param || rowDelete,
      setConfirmModal,
      setWarningModal,
      setRowDelete,
    })
    if (confirmModal) setRowDelete({})
  }

  const onDeleteMultipleRows = rowsState => {
    onDeleteIndividual({ individuals: rowsState, callback: resetState })
  }

  const onDeleteSingleRow = rowsState => {
    onDeleteIndividual({
      individuals: rowsState,
      callback: () => {
        setRows(prev => prev.filter(x => x.id !== rowDelete.id))
      },
    })
    setRowDelete({})
    setRow({})
  }

  const onDeleteIndividualHandler = () => {
    onDelete({
      rowDelete,
      rows,
      onDeleteSingleRow,
      onDeleteMultipleRows,
    })
    // toggle modal
    setConfirmModal(false)
  }

  /**Get selected row and set to state
   *
   */
  const onSelectCheckbox = (row, isSelected) => {
    const { rowsState, currentRow } = selectCheckboxHandler(
      rows,
      row,
      isSelected
    )
    setRows(rowsState)
    setRow(currentRow)
  }

  const onSelectAllCheckbox = rows => {
    setRows(rows)
    if (rows.length < 1) setRow({})
    else setRow(rows[rows.length - 1])
  }

  const fetchIndividuals = () => {
    onGetIndividualList({ page: 1, sort: "createdDate:desc" })
  }

  /** Table methods */
  const onRefreshHandler = () => {
    resetState()
    fetchIndividuals()
  }

  const onSearch = searchText => {
    onGetIndividualList({ page: 1, search: searchText })
  }

  const onSizePerPageChange = size => {
    onGetIndividualList({ page: 1, size })
  }

  const onPageChange = page => {
    onGetIndividualList({ page })
  }

  const onSubmitFilter = values => {
    const formattedValues = {
      ...values,
      start: moment(values.start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      end: moment(values.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
    }
    onGetIndividualList({ page: 1, ...formattedValues })
  }

  const onSortHandler = (field, order) => {
    const sortString = `${field}:${order}`
    onGetIndividualList({ page: 1, sort: sortString })
  }

  /**-----CYCLE------ */

  useEffect(() => {
    onResetIndividualSearchQuery()
  }, [])

  useEffect(() => {
    let params = getUrlParams();
    let paramPage = getUrlParamByKey("page");
    if (paramPage) {
      onGetIndividualList(params)
    } else {
      fetchIndividuals()
    }
  }, [])

  useEffect(() => {
    setRowEdit(individual)
  }, [individual])

  return (
    <React.Fragment>
      {/* Body */}
      <TitleAndTable
        table={() => (
          <IndividualTable
            individuals={individuals}
            onSelect={onSelectCheckbox}
            onSelectAll={onSelectAllCheckbox}
            onSearch={onSearch}
            onSort={onSortHandler}
            onRefresh={onRefreshHandler}
            onPageChange={onPageChange}
            paging={paging}
            onSizePerPageChange={onSizePerPageChange}
            onSubmitFilter={onSubmitFilter}
            onEdit={onEditHandler}
            onDelete={onDeleteToggleHandler}
            onClone={onCloneHandler}
            loading={loadingIndividuals}
            updatedTime={updatedIndividualTime}
          />
        )}
        resource={RESOURCE}
        buttons={() => (
          <Check permission={permissionType.C} resource={RESOURCE}>
            <CustomButton color="primary" onClick={addIndividualClicks} outline>
              {t("common:Add")}
            </CustomButton>
            <CustomButton color="primary" onClick={(e) => { onDeleteToggleHandler(e, rows.id) }} outline>
              {t("common:Delete")}
            </CustomButton>
          </Check>
        )}
        onEdit={onEditHandler}
        onDelete={onDeleteToggleHandler}
        onClone={onCloneHandler}
        isDisableClone
        isHideEdit
        isDropDown
        title={t("Individuals")}
        subtitle={t("Individual List")}
      />
      <WarningModal
        modal={warningModal}
        onToggle={() => setWarningModal(prev => !prev)}
        message={t("message:SelectRowWarning")}
      />
      <ConfirmModal
        modal={confirmModal}
        title={`${t("common:Delete")} ${t("Individual")}`}
        message={t("message:DeleteConfirm")}
        onToggle={onDeleteToggleHandler}
        onDelete={onDeleteIndividualHandler}
      />
      {(isEdit || isClone) && !isEmptyValues(rowEdit) && (
        <FieldFormModal
          modal={modal}
          toggle={toggle}
          profileId={rowEdit.ProfileId}
          profileName={rowEdit.ProfileName}
          onSubmit={handleValidSubmit}
          isEdit={isEdit}
          isClone={isClone}
          data={rowEdit}
        />
      )}

      <SelectProfileModal
        modal={selectModal}
        isEdit={isEdit || isClone}
        toggle={() => setSelectModal(prev => !prev)}
        onSubmit={handleValidSubmit}
        data={!isEdit && !isClone ? rowAddNew : rowEdit}
        resource={RESOURCE}
      />
    </React.Fragment>
  )
}

Individuals.propTypes = {
  individuals: PropTypes.array,
  onGetIndividualDetail: PropTypes.func,
  onGetIndividuals: PropTypes.func,
  onAddNewIndividual: PropTypes.func,
  onUpdateIndividual: PropTypes.func,
  onDeleteIndividual: PropTypes.func,
  onResetIndividualSearchQuery: PropTypes.func,
  paging: PropTypes.object,
  loadingIndividuals: PropTypes.bool,
  updatedIndividualTime: PropTypes.any,
  t: PropTypes.any,
}

const mapStateToProps = ({ individual }) => ({
  individuals: individual.individuals,
  individual: individual.individual,
  paging: individual.paging,
  loadingIndividuals: individual.loadingIndividuals,
  updatedIndividualTime: individual.updatedIndividualTime,
})

const mapDispatchToProps = dispatch => ({
  onGetIndividuals: payload => dispatch(getIndividuals(payload)),
  onAddNewIndividual: (individual, history) =>
    dispatch(addNewIndividual(individual, history)),
  onUpdateIndividual: individual => dispatch(updateIndividual(individual)),
  onDeleteIndividual: individual => dispatch(deleteIndividuals(individual)),
  onGetIndividualDetail: individualId =>
    dispatch(getIndividualDetail(individualId)),
  onResetIndividualSearchQuery: () => dispatch(resetIndividualSearchQuery()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["partyPage", "message", "common"])(Individuals)))
